import { axiosInstance } from '@refinedev/simple-rest'
import Cookies from 'js-cookie'
import { useLoadingStore } from 'src/stores/LoadingStore'
import { USER_VALIDATE } from './Routes'

axiosInstance.defaults.baseURL = process.env.NEXT_PUBLIC_API_URL

const urlsWOLoading = [USER_VALIDATE + `${Cookies.get('token')}`]

axiosInstance.interceptors.request.use(config => {
  const token = Cookies.get('token')

  if (!urlsWOLoading.includes(config.url || '')) {
    useLoadingStore.getState().startLoading()
  }

  if (config.headers && token) {
    config.headers['Authorization'] = `Bearer ${token}`
  }

  return config
})

axiosInstance.interceptors.response.use(
  response => {
    if (!urlsWOLoading.includes(response.config.url || '')) {
      useLoadingStore.getState().stopLoading()
    }
    return response
  },
  error => {
    useLoadingStore.getState().stopLoading()
    return Promise.reject(error)
  }
)

export default axiosInstance
